import {request} from './client';
import type {LoginRequest, RegisterRequest, UserResponse} from '@/types/api';

export type {LoginRequest, RegisterRequest, UserResponse};

export const authApi = {
	async login(payload: LoginRequest) {
		return request<UserResponse>('/api/auth/login', {method: 'POST', body: payload});
	},
	async register(payload: RegisterRequest) {
		return request<UserResponse>('/api/auth/register', {method: 'POST', body: payload});
	},
	async me() {
		return request<UserResponse>('/api/auth/me', {method: 'GET'});
	},
	async logout() {
		return request<undefined>('/api/auth/logout', {method: 'POST'});
	},
};
